import React from 'react';
import { TimePicker as TimePickerNew } from './TimePicker';
import { convertOldTimePickerProps, OldTimePickerProps } from './converter.old';

export type TimePickerProps = OldTimePickerProps;
export const TimePicker: React.FC<TimePickerProps> = (props) => <TimePickerNew {...convertOldTimePickerProps(props)} />;
